import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f21aa62"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "asArticleCard",
  "data-test": "article-card"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "labels" }
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = { class: "actions_wrap" }
const _hoisted_6 = {
  key: 1,
  class: "views"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_8 = { class: "date" }
const _hoisted_9 = { class: "description" }
const _hoisted_10 = {
  key: 0,
  class: "text"
}
const _hoisted_11 = { class: "more" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_heart = _resolveComponent("icon-heart")!
  const _component_icon_favourite = _resolveComponent("icon-favourite")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "preview",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openArticle && _ctx.openArticle(...args)))
    }, [
      _createElementVNode("img", {
        class: "preview_img",
        src: _ctx.article.previewImage,
        alt: _ctx.article.title
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.article.labels, (label) => {
          return (_openBlock(), _createElementBlock("span", {
            key: label,
            class: "label"
          }, _toDisplayString(label), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.article.hasOwnProperty('liked'))
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["like", { '-active': _ctx.article.liked }])
            }, [
              _createVNode(_component_icon_heart),
              _createTextVNode(" " + _toDisplayString(_ctx.article.likesCount), 1)
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.article.hasOwnProperty('countViews'))
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('countViews')) + " " + _toDisplayString(_ctx.article.countViews), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.article.hasOwnProperty('isFavourite'))
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleFavourite && _ctx.toggleFavourite(...args))),
            class: _normalizeClass(["favourite", { '-active': _ctx.article.isFavourite }])
          }, [
            _createVNode(_component_icon_favourite)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _hoisted_7,
    _createElementVNode("div", {
      class: "content",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openArticle && _ctx.openArticle(...args)))
    }, [
      _createElementVNode("time", _hoisted_8, _toDisplayString(_ctx.date), 1),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.article.shortDescription)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
              _createTextVNode(_toDisplayString(_ctx.article.shortDescription) + " ", 1),
              _createElementVNode("span", _hoisted_11, "... " + _toDisplayString(_ctx.$t('more')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}